import { useCallback } from 'react';
import type { SurveyLanguage } from '@shared/types/surveyLanguage';
import { clearSurveyLanguage, setSurveyLanguage } from '@/stores/appSlice';
import { useAppDispatch, useAppSelector } from '@/stores/hooks';
import { selectSurveyLanguage } from '@/stores/selectors';

export function useSurveyLanguage() {
  const dispatch = useAppDispatch();
  const surveyLanguage = useAppSelector(selectSurveyLanguage);

  const choose = useCallback(
    (lang: SurveyLanguage) => {
      dispatch(setSurveyLanguage(lang));
    },
    [dispatch]
  );

  const clear = useCallback(() => {
    dispatch(clearSurveyLanguage());
  }, [dispatch]);

  return {
    surveyLanguage,
    setSurveyLanguage: choose,
    clearSurveyLanguage: clear,
    isEnglish: surveyLanguage === 'en',
    isBahasaMalaysia: surveyLanguage === 'bm',
  };
}
